const COMPONENT_NAME = "SkipLink";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: invalid props - missing targetId and/or skipLinkText`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR
};
